import { forwardRef } from 'react';

const Frame = forwardRef(
    ({ children, title }, ref) => {
        return (
            <div ref={ref} className="w-3/4 lg:w-4/5 relative p-4">
                <div className="border-t-2 border-l-2 border-white w-10 h-10 md:w-20 md:h-20 lg:w-32 h-32 absolute top-0 left-0" />
                <div className="border-t-2 border-r-2 border-white w-10 h-10 md:w-20 md:h-20 lg:w-32 h-32 absolute top-0 right-0" />
                <div className="border-b-2 border-l-2 border-white w-10 h-10 md:w-20 md:h-20 lg:w-32 h-32 absolute bottom-0 left-0" />
                <div className="border-b-2 border-r-2 border-white w-10 h-10 md:w-20 md:h-20 lg:w-32 h-32 absolute bottom-0 right-0" />

                {children}

                <div className="w-full -bottom-3 lg:-bottom-6 absolute text-center rubrik-regular text-lg md:text-xl lg:text-2xl">
                    01:22:11:00
                </div>
            </div>
        );
    }
);

export default Frame;
